import { PermissionKey } from '../../../../../components/Access/helper/permission/enum/PermissionKey';
import { PermissionInfo } from './options';

function getTreeData() {
    const parents = {};

    Object.keys(PermissionKey).forEach(key => {
        const permissionKey = PermissionKey[key];
        const { title, maxLevel, modifier, hidden } = PermissionInfo[permissionKey] || {};

        if (!title || hidden)
            return null;

        // Is Leaf
        if (permissionKey.includes('.')) {
            const parentPermissionKey = permissionKey.split('.')[0];

            if (!parents[parentPermissionKey]) {
                const { title, maxLevel, modifier } = PermissionInfo[parentPermissionKey] || {};
                parents[parentPermissionKey] = {
                    title,
                    maxLevel,
                    modifier,
                    key: parentPermissionKey,
                    children: [],
                };
            }
            parents[parentPermissionKey].children.push({
                title,
                maxLevel,
                modifier,
                key: permissionKey,
                isLeaf: true,
            });
        }
        // Is Parent
        else {
            parents[permissionKey] = {
                title,
                maxLevel,
                modifier,
                key: permissionKey,
                children: [],
            };
        }
        return null;
    });
    return Object.values(parents).map(i => ({ ...i, isLeaf: i.children.length === 0 }));
}

export const treeData = getTreeData();
export const flattenTreeData = treeData.flatMap(data => {
    if (!data.children)
        return [data];
    return [data, ...data.children.map(child => ({...child, parent: data}))];
});
